<!-- هدر اصلی سایت -->

<div class="bg-th-yellow mt-0 container-fluid py-2">

    <div class=" d-flex justify-content-between align-content-center">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <a class="text-dark fw-bold my-auto dirI d-flex align-items-center">

            نقش و دسترسی های نقش

        </a>

    </div>

</div>

<!-- محتوای صفحه -->

<section class="p-2" style="direction: rtl;">

    <div class="border border-2 mt-3 p-2">

        <div class="row gx-md-2 gx-0 px-1">

            <div class="col-12 col-md-11">

                <input type="text" class="w-100 form-control" placeholder="جستجو کنید ..."
                    (keyup)="filter_list($event.target)">

            </div>

            <div class="col-12 col-md-1 d-flex align-items-center">

                <button class="btn btn-success w-100" (click)="openModal()"> افزودن </button>

            </div>

        </div>

        <div class="section border border-2 mt-2" style="height:calc(100vh - 170px);overflow: auto;">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead>

                    <tr class="">

                        <th class="text-center col-1"> # </th>

                        <th class="text-center"> عملیات </th>

                        <th class="text-center"> عنوان </th>

                    </tr>

                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of lst_Roles;let i = index">

                        <th> {{ i + 1 | faNum }} </th>

                        <th class="d-flex flex-wrap justify-content-center gap-2 f18">

                            <i class="text-primary pointer fa fa-edit" (click)="openModal(item,true,i)"
                                title="ویرایش"></i>

                            <i class="text-danger pointer fa fa-trash" (click)="remove_Role(item,i)" title="حذف"></i>

                            <i class="text-dark pointer fa fa-hand-paper-o" (click)="getRoleAccess(item)"
                                title="دسترسی"></i>


                        </th>

                        <td> {{ item.strComment }} </td>

                    </tr>

                </tbody>

            </table>

        </div>

    </div>

</section>

<!-- فرم افزودن و ویرایش نقش -->

<div class="modal fade" id="Role_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> {{ bEditMode ? 'ویرایش نقش' : 'ثبت نقش جدید' }} </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div [formGroup]="mdl_Role" class="container-fluid row gx-2 gy-2 p-2">

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> عنوان نقش </label>

                        <input class="form-control p-2 text-center" formControlName="strComment">

                    </div>

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn" [ngClass]="bEditMode ? 'btn-primary' : 'btn-success' " (click)="submitRole()">

                    &nbsp; &nbsp; {{ bEditMode ? 'ویرایش' : 'ذخیره' }} &nbsp; &nbsp;

                </button>


                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>

<!-- فرم افزودن دسترسی به نقش -->

<div class="modal fade" id="Access_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h6 class="modal-title" id="exampleModalLabel">

                    دسترسی های نقش

                    <span class="fw-bold"> {{mdl_Role.get('strComment')?.value}} </span>

                </h6>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div class="section border border-2 mt-2" style="max-height:60vh;overflow: auto;">

                    <div class="col-12 p-3">

                        <input type="text" class="w-100 form-control" placeholder="جستجو کنید ..." (keyup)="filter_list2($event.target)">

                    </div>


                    <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                        <thead>

                            <tr class="">

                                <th class="text-center col-1"> # </th>

                                <th class="text-center"> اختصاص </th>

                                <th class="text-center"> نوع دسترسی </th>

                            </tr>

                        </thead>

                        <tbody>

                            <tr class="col-12 text-center" *ngFor="let item of lst_Access;let i = index">

                                <th> {{ i + 1 | faNum }} </th>

                                <td (click)="addOrRemoveAccess(item.strXenotakAbility)">

                                    <input type="checkbox" [checked]="item.bHas == 0 ? false : true ">

                                </td>

                                <td> {{ item.strComment }} </td>

                            </tr>

                        </tbody>

                    </table>

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-primary" (click)="addAllAccess(1)">

                    &nbsp; &nbsp; اضافه کردن همه &nbsp; &nbsp;

                </button>

                <button class="btn btn-danger" (click)="addAllAccess(0)">

                    &nbsp; &nbsp; حذف همه &nbsp; &nbsp;

                </button>

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>